module.exports = __webpack_public_path__ + "img/shipo-date-picker-icon-calendar.c1108880.svg";